/** mock 的演示账号（放在独立文件，避免正式构建把整个 mock 后端打进主包） */
export const DEMO_EMAIL = "demo@example.com";
export const DEMO_PASSWORD = "password123";
